// extracted by mini-css-extract-plugin
export default {"overlayProvider":"OverlayProvider_overlayProvider__HYGc3"};